import React, { useState } from "react";
import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { Scrollbars } from "react-custom-scrollbars";

type Props = {
  name: string;
  label: string;
  options: Array<{ value: string; label: string }>;
  disabled?: boolean;
  selectedValue?: string;
  key?: string;
  changeHandler?: (e:any) => void;
  control: any;
  menuMaxHeight?: number,
  defaultValue?: any
  sx?: any
};

const slotProps: any = {
  select: {
    MenuProps: {
      PaperProps: {
        sx: {
          maxHeight: 250,
          "&::-webkit-scrollbar": {
            width: "0.3em",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#999",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
          },
        }
      }
    }
}}

const  FieldInputSelect = ({ name, label, options, disabled, control, selectedValue, changeHandler, menuMaxHeight, defaultValue = '' }: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const { onChange, value, ...rest } = field
        const inputValue =  (value === undefined || value === null ||options.length === 0) ? '' : value;

        return (
          <TextField
            select
            value={inputValue}
            //defaultValue={inputValue}
            slotProps={slotProps}
            onChange={(e) => {
              changeHandler && changeHandler(e);
              onChange(e);
            }}
            // onChange={onChange}
            label={label}
            size="small"
            helperText={`${error?.message || ""}`}
            error={!!error}
            disabled={disabled}
          >
                {options && options.map((option, idx) => (
                  <MenuItem 
                    key={`option-${idx}-${option.value}`} 
                    //selected={selectedValue && selectedValue === option.value ? true : false} 
                    value={option.value}
                  >
                    {option.label}
                  </MenuItem>
                ))}
          </TextField>
        );
      }}
    />
  );
}

export default FieldInputSelect;
